// extracted by mini-css-extract-plugin
export var styles = "content-module--styles--2IZ5S";
export var zzz = "content-module--zzz--1rS_n";